export type TriggeredModule = 'alert' | 'resources' | 'notifications';

export const TriggeredModules = {
  alert: 'alert' as TriggeredModule,
  resources: 'resources' as TriggeredModule,
  notifications: 'notifications' as TriggeredModule
}
